<!-- Setup for the Dialog and Toast for the root level access -->
<p-confirmDialog header="Confirmation" key="confirm" icon="pi pi-exclamation-triangle" [style]="{width: '350px'}"
    acceptButtonStyleClass="p-button-text" rejectButtonStyleClass="p-button-text"></p-confirmDialog>
<p-toast></p-toast>
<!-- Setup for the Dialog and Toast for the root level access -->
<router-outlet></router-outlet>